module.exports = __webpack_public_path__ + "static/media/utilities.0e0d9428.svg";